export interface IPeriod {
  name: string
  description?: string
  startDate: Date | null
  endDate: Date | null
  rawStartDate: Date | null
  rawEndDate: Date | null
}

export const CollectionType = { Noos: "noos", Mixed: "mixed" } as const
export type ICollectionType = (typeof CollectionType)[keyof typeof CollectionType]

export const CollectionSource = { Erp: "erp", Manual: "manual" } as const
export type ICollectionSource = (typeof CollectionSource)[keyof typeof CollectionSource]

// Piloted on one tenant before it opens to every tenant whose sales carry a collection id.
export const manualErpCollectionOrgs = new Set(["by_bar"])

const collectionTypeLabels: Record<string, string> = {
  noos: "NOOS",
  mixed: "Fashion",
}

export function getCollectionTypeLabel(type: string): string {
  return collectionTypeLabels[type] ?? type
}

export interface IBulkRemoveCollectionResult {
  id: number
  name: string
}

export interface IBulkRemoveCollectionError {
  id: number
  name?: string
  error: string
}

export interface IBulkRemoveCollectionsResponse {
  removed: IBulkRemoveCollectionResult[]
  deactivated: IBulkRemoveCollectionResult[]
  failed: IBulkRemoveCollectionError[]
  unpublishedVariantIds: string[]
  cleanupError?: string
}
